var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.82436 14.8533V8.65318L9.55801 8.26476L10.0045 5.44569L6.82436 5.89757V4.55558C6.82436 3.84601 6.85068 3.13821 8.29063 2.93361L9.74909 2.72637V0.756103C9.74909 0.72648 8.49633 0.837663 7.22895 1.01775C4.58207 1.39385 2.92473 2.77086 2.92473 4.86719V6.45167L0 6.86725V9.62287L2.92473 9.20729V15.4074L6.82436 14.8533Z","fill":"#E2231A"}));
}

FacebookIcon.defaultProps = {"width":"11","height":"16","viewBox":"0 0 11 16","fill":"none"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
